import { GroupByTransformPlainObject } from './groupByTransform.plainObject';

export class AggregatePlainObject extends GroupByTransformPlainObject {
}
